<template>
  <section id="mainContainer">
    <adminHeader></adminHeader>
    <section class="admin-mid-container">
      <div class="admin-custom-row admin-page-row" id="leftMenuSlideBox">
        <adminNavigation></adminNavigation>
        <section class="admin-right-sidebar">
          <div class="admin-right-sidebar-in">
            <div class="admin-right-sidebar-in-top">
              <div class="admin-custom-row">
                <h1>{{ constants.CHANGE_PASSWORD_TEXT }}</h1>
              </div>
            </div>
            <div class="white-bg-border">
              <div class="change-password-section">
                <form @submit.prevent="handleSubmit" id="changePasswordForm">
                  <div class="change-password-form">
                    <div class="admin-input-field">
                      <label>{{ constants.OLD_PASSWORD_LABEL }}</label>
                      <input id="cPwdOldPwdInput" v-model="current_password" type="password" name="current_password"
                        placeholder="Enter old password" @input="errorMsg = ''"/>
                    <div class="error-msg" v-if="errorMsg==='Incorrect current password.'||!current_password">{{errorMsg}}</div>
                    </div>
                    <div class="admin-input-field">
                      <label>{{ constants.NEW_PASSWORD_LABEL }}</label>
                      <input id="cPwdNewPwdInput" v-model="new_password" type="password" name="new_password"
                        placeholder="Enter new password" @input="errorMsg = ''" />
                    <div class="error-msg" v-if="errorMsg==='New password and confirm password do not match.'||errorMsg==='New password cannot be the same as the Old password.'||!new_password">{{errorMsg}}</div>

                    </div>
                    <div class="admin-input-field">
                      <label>{{ constants.CONFIRM_PASSWORD_LABEL }}</label>
                      <input id="cPwdCPwdInput" v-model="confirm_password" type="password" name="confirm_password"
                        placeholder="Enter confirm password" />
                        <div class="error-msg" v-if="!confirm_password">{{errorMsg}}</div>
                    </div>
                    <div class="admin-input-field-submit">
                      <button id="cPwdSubmitBtn" type="submit" class="admin-btn-outline-primary">
                        {{ constants.SUBMIT_BUTTON }}
                      </button>
                      <button id="cPwdCancelBtn" type="button" @click="handleCancel" class="admin-btn-outline-secondary">
                        {{ constants.CANCEL_BUTTON }}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
    <footer class="admin-site-footer">
      <div class="container">
        {{ constants.COPYRIGHT_TEXT }}
      </div>
    </footer>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import axios from "axios";
import constants from "@/utils/en-US-Admin.json";
import adminHeader from "@/components/adminHeader.vue";
import adminNavigation from "@/components/adminNavigation.vue";
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import Swal from "sweetalert2";
import { API_BASE_URL } from "@/config/api.config";

export default defineComponent({
  name: "AdminChangePassword",
  data() {
    return {
      constants,
      current_password: "",
      new_password: "",
      confirm_password: "",
      errorMsg: "",
    };
  },
  beforeRouteEnter(
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (isLoggedIn !== "true") {
      next({ name: 'Login' });
    } else {
      next();
    }
  },
  components: {
    adminHeader,
    adminNavigation,
  },
  methods: {
    async handleSubmit() {
      
      if(!this.current_password || !this.new_password || !this.confirm_password){
        this.errorMsg = 'This field is required';
        return

      }
      if(this.current_password && this.new_password && this.confirm_password){
        
        const adminId = localStorage.getItem('admin_id');
        const response = await axios.post(`${API_BASE_URL}/change-password/${adminId}/`, {
          current_password: this.current_password,
          new_password: this.new_password,
          confirm_new_password: this.confirm_password
        });
        
        if (response.status === 200) {
       this.errorMsg = response.data.error
      }else{
        Swal.fire({
          icon: 'success',
          title: 'Password Updated Successfully!',
          showConfirmButton: false,
          timer: 1500
        });
        this.clearForm()
      }     
      }

    },
    handleCancel() {
      this.clearForm();
    },
    clearForm() {
      this.current_password = "";
      this.new_password = "";
      this.confirm_password = "";
      this.errorMsg = "";
    }
  },
});
</script>